import type { MessageDescriptor } from 'react-intl';
import type { OutreachPitchKind } from 'fym-shared/src/music24/outreach/dailyPitches';
import { campaignMessages as messages } from './campaignMessages';

/** The tab label of each kind of the sample pitch (design outreach-v2 d1). */
export const SAMPLE_KIND_TAB: Record<OutreachPitchKind, MessageDescriptor> = {
  spotifyPlaylist: messages.sampleKindSpotifyPlaylist,
  otherPlaylist: messages.sampleKindOtherPlaylist,
  press: messages.sampleKindPress,
  newsletter: messages.sampleKindNewsletter,
  radio: messages.sampleKindRadio,
  podcast: messages.sampleKindPodcast,
  creator: messages.sampleKindCreator,
};

/** The sample person of each kind in the "To:" line ("a Spotify curator who added …"). */
export const SAMPLE_KIND_PERSON: Record<OutreachPitchKind, MessageDescriptor> = {
  spotifyPlaylist: messages.samplePersonSpotifyPlaylist,
  otherPlaylist: messages.samplePersonOtherPlaylist,
  press: messages.samplePersonPress,
  newsletter: messages.samplePersonNewsletter,
  radio: messages.samplePersonRadio,
  podcast: messages.samplePersonPodcast,
  creator: messages.samplePersonCreator,
};
